import React, { Fragment } from 'react';
import { Col } from 'reactstrap';

export default function Maintenance() {
    const maintenanceMessage = document.SENIOR_LINK_MAINTENANCE_MESSAGE;
    return (
        <Fragment>
            <div className="h-100 bg-animation">
                <div className="d-flex h-100 justify-content-center align-items-center">
                    <Col md="8" className="mx-auto app-login-box">
                        {/* <a href={webPageUrl} target="_blank" rel="noopener noreferrer"> */}
                            <div className="app-logo-inverse mx-auto mb-3" />
                        {/* </a>                */}

                        <div className="modal-dialog w-100 mx-auto">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <div className="h5 modal-title text-center">
                                        <h4 className="mt-2">
                                            <div>Seniors Living In Neighborhood Kindness</div>
                                            <span>
                                                {maintenanceMessage}
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </Col>
                </div>
            </div>
        </Fragment>
    );
}
